import React from 'react';
import { 
    Edit, 
    SimpleForm, 
    TextInput,
    ReferenceInput,
    SelectInput,
    required,
    usePermissions
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";
import { processPermissions } from "../../common/roleUtils";

export const SectionEdit = props => {
    const { permissions } = usePermissions();
    let propsObj = { ...props };
    
    if (permissions) {
        // Use utility function to process permissions with role-based restrictions
        const processedPermissions = processPermissions(permissions, props.resource);
        propsObj = { ...propsObj, ...processedPermissions };
    }
    
    return (
        <React.Fragment>
            <Edit label="Edit Section" {...propsObj}>
                <SimpleForm toolbar={<FormToolbar {...propsObj} hasDelete={true}/>}>
                    <ReferenceInput 
                        source="class_id" 
                        reference="genere" 
                        label="Class"
                        fullWidth
                    >
                        <SelectInput optionText="class_name" validate={[required()]} fullWidth={true} />
                    </ReferenceInput>
                    
                    <TextInput 
                        source="section" 
                        label='Section Name' 
                        fullWidth={true}
                        validate={[required()]} 
                        helperText="E.g., A, B, C, etc."
                    />
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
}
